import isNull from 'lodash/isNull';
import React from 'react';
import { InputNumber, Slider } from '@meitu/saas-ui';
import './enhance-slider.less';
import './slider-bar.less';
import classnames from 'classnames';

interface ISliderProps {
    // 背景样式
    background?: any;
    wrapBackground?: any;
    // 标题
    title?: string;
    // 最大值
    maxVal?: number;
    // 最小值
    minVal?: number;
    // 当前值
    value: number;
    onChange: (value: number) => void;
    onAfterChange?: (value: number) => void;
    marks?: any;
    step?: number | null;
    tooltipPlacement?: any;
    opacityOpposite?: boolean;
}

/**
 * @description 滑动 + 输入框组件
 * @param prop SliderPropType
 * @returns
 */
const EnhanceSlider = (prop: ISliderProps) => {
    const {
        background,
        wrapBackground,
        title = '',
        minVal = 0,
        maxVal = 100,
        value = 0,
        onChange,
        onAfterChange,
        step = 1,
        marks = {},
        tooltipPlacement = 'top',
        opacityOpposite = false,
    } = prop;

    const sliderStyle = {} as React.CSSProperties;
    const wrapStyle = {} as React.CSSProperties;

    sliderStyle.opacity = opacityOpposite ? 1 - Math.abs((value + 100) / 200) : Math.abs((value + 100) / 200);

    const toFixedNum = (val: number) => {
        return +val.toFixed(0);
    };
    return (
        <div className="enhance-slider-input">
            <div className="row-slider">
                <div className="row-slider__up" style={wrapStyle}>
                    {!background.useStyle ? (
                        <img src={background?.default || background} alt="" />
                    ) : (
                        <div className={classnames(background.classname)} style={{ width: '100%', height: '100%' }} />
                    )}
                </div>
                <div className="row-slider__under" style={sliderStyle}>
                    {!wrapBackground.useStyle ? (
                        <img src={wrapBackground?.default || wrapBackground} alt="" />
                    ) : (
                        <div
                            className={classnames(wrapBackground.classname)}
                            style={{ width: '100%', height: '100%' }}
                        />
                    )}
                </div>
                {/* 滑动条 */}
                <Slider
                    className="row-slider__main"
                    max={maxVal}
                    min={minVal}
                    value={value}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        margin: 0,
                    }}
                    tooltip={{ placement: tooltipPlacement }}
                    onAfterChange={(val) => {
                        onAfterChange?.(val);
                    }}
                    onChange={onChange}
                    marks={marks}
                    step={step}
                />
                {/* 标题 */}
                {title ? <div className="row-slider__title">{title}</div> : null}
            </div>
            {/* 输入框 */}
            <InputNumber
                width={40}
                height={24}
                max={maxVal}
                min={minVal}
                onChange={(e: number | null) => {
                    if (isNull(e)) return;
                    onChange(e);
                }}
                onChangeAfter={(e: number | null) => {
                    if (isNull(e)) return;
                    onAfterChange?.(e);
                }}
                value={toFixedNum(value)}
            />
        </div>
    );
};
export default React.memo(EnhanceSlider);
